<template>
    <teleport to="body">
        <ModalOverlay v-if="showBanner" :show="showBanner" @bounce="bounce()" :close="false">
            <div class="fixed bottom-10 container right-0 sm:right-auto">
                <div v-if="showBanner" :class="{'animate-bounce': bounceEffect}" class="left-auto right-auto rounded pb-5 pt-3 w-100 max-w-screen-xl bg-white border-t-4 border-purple-600">
                    <AppContainer classes="fixed bottom-10">
                        <h2 class="bold mb-3 text-2xl">We value your privacy</h2>
                        <div class="flex flex-col md:flex-row items-center gap-4">
                            <p class="flex-grow text-center md:text-left">
                                We use cookies to help keep our site safe, give you a better experience and show you more relevant ads.
                            </p>

                            <div class="flex gap-4">
                                <AppButton size="small" theme="secondary" @click="manageCookieSettings()">Change preferences</AppButton>

                                <form @submit.prevent="submitCookieForm()">
                                    <input type="hidden" name="_token" :value="usePage().props.value.csrf">

                                    <AppButton size="small" theme="primary" type="submit">
                                        Accept All
                                    </AppButton>
                                </form>
                            </div>
                        </div>
                    </AppContainer>
                </div>
            </div>
        </ModalOverlay>
        <CookieModal
            :show-cookie-modal="showCookieModal"
            :performance-cookie="usePage().props.value.cookies.performance"
            :advertising-cookie="usePage().props.value.cookies.advertising"
            :functional-cookie="usePage().props.value.cookies.functional"
            @toggleModal="toggleModal()"
            @closeModal="closeModal()"
        ></CookieModal>
    </teleport>
</template>

<script setup>
import {usePage} from "@inertiajs/inertia-vue3";
import AppContainer from "@/Layouts/AppContainer";
import ModalOverlay from "@/Components/Modals/ModalOverlay";
import CookieModal from "@/Components/Modals/CookieModal";
import AppButton from "@/Components/AppButton";
import {onMounted, ref, reactive} from "vue";
import {useGtag} from "vue-gtag-next";

const showBanner = ref(false);
const showCookieModal = ref(false);
const bounceEffect = ref(false);

onMounted(() => {
    checkCookies();
});

function bounce() {
    bounceEffect.value = true;
    setTimeout(() => bounceEffect.value = false, 2000);
}

const checkCookies = async () => {
    const response = await axios.get(route("cookies.check"));

    showBanner.value = !response.data.has_accepted_cookies;
};

async function submitCookieForm() {
    const response = await axios.post(route('accept-all-cookies'));

    const {query} = useGtag();

    query('consent', 'update', {
        'analytics_storage': 'granted',
        'ad_storage': 'granted',
        'ad_user_data': 'granted',
        'ad_personalization': 'granted'
    });

    showBanner.value = false;
}

function manageCookieSettings() {
    showBanner.value = false;
    showCookieModal.value = true;
};

function toggleModal() {
    showBanner.value = true;
    showCookieModal.value = false;
}

function closeModal() {
    showCookieModal.value = false;
}
</script>

<style scoped>

</style>
